// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"f8071b9f","239":"9dc7f5ec","658":"e6a8eb15"}[chunkId] + ".chunk.js";
};